import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-14 ant-col-xl-14",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-margin-campos" }, "ADICIONAR VARIÁVEIS:")
], -1)
const _hoisted_5 = { class: "ant-col ant-col-xs-10 ant-col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form_item, {
          label: "Informação Complementar",
          class: "ss-margin-campos"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("textarea", {
              placeholder: "Digite sua mensagem aqui",
              rows: "5",
              class: "ant-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedInformacaoComplementar) = $event))
            }, null, 512), [
              [_vModelText, _ctx.computedInformacaoComplementar]
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarVariavel('Total da Nota')))
        }, "Total da Nota"),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-secondary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adicionarVariavel('Total dos produtos')))
        }, "Total dos produtos"),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-secondary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.adicionarVariavel('Imposto dispensado')))
        }, "Imposto dispensado")
      ])
    ])
  ], 64))
}